module.exports = __webpack_public_path__ + "img/blank_page.8f92f107.svg";